import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_available_inventory_by_licenseplateId_lotId_packagedIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { lotId: number, packagedId: number, licenseplateId: number }): 
  Promise<{ result: { TotalAvailablePackagedAmount?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.lotId)) {
      $missingRequiredInParams.push('\'lotId\'');
    }
    if (isNil($inParams.packagedId)) {
      $missingRequiredInParams.push('\'packagedId\'');
    }
    if (isNil($inParams.licenseplateId)) {
      $missingRequiredInParams.push('\'licenseplateId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      lotId: number, packagedId: number, licenseplateId: number    }) {
        if(isNil($inParams.lotId)) {
          return true; 
        }
        if(isNil($inParams.packagedId)) {
          return true; 
        }
        if(isNil($inParams.licenseplateId)) {
          return true; 
        }
      return false;
    }
}
